// Serialized verbatim into ld+json scripts — key order is part of the output.
export const ORGANIZATION_JSON_LD = {
  url: "https://maticrobots.com",
  logo: "https://dt8esguquqvs0.cloudfront.net/assets/favicons/192x192.png",
  name: "Matic Robots",
  "@type": "Organization",
  brand: {
    url: "https://maticrobots.com",
    name: "Matic Robots",
    "@type": "Brand",
  },
  email: "hello@maticrobots.com",
  sameAs: [
    "https://www.instagram.com/maticrobots/",
    "https://x.com/maticrobots",
    "https://www.linkedin.com/company/maticrobots",
    "https://www.youtube.com/@maticrobots",
  ],
  "@context": "https://schema.org",
  keywords: "Matic, Matic Robots, Robot Vacuum",
  description:
    "The world’s most advanced floor cleaner. Your home’s best helper.",
};

type BreadcrumbItem = {
  position: number;
  name: string;
  item: string;
};

const HOME_CRUMB: BreadcrumbItem = {
  item: "https://maticrobots.com/",
  name: "Matic Robots",
  position: 1,
};

const crumb = (path: string, name: string): BreadcrumbItem[] => [
  HOME_CRUMB,
  { item: `https://maticrobots.com/${path}`, name, position: 2 },
];

export const BREADCRUMB_META_DATA = {
  home: [HOME_CRUMB],
  press: crumb("press", "Press | Matic"),
  terms: crumb("terms", "Terms of Service | Matic"),
  careers: crumb("careers", "Careers | Matic"),
  privacy: crumb("privacy-policy", "Privacy Policy | Matic"),
  product: crumb("product", "Shop Matic"),
  warranty: crumb("warranty", "Warranty | Matic"),
  betatesting: crumb("betatesting", "Beta Tester Agreement | Matic"),
  orderConfirm: crumb("order-confirm", "Thank you | Matic"),
  "return-policy": crumb("return-policy", "Return Policy | Matic"),
} satisfies Record<string, BreadcrumbItem[]>;
